<template>
    <div>
        You are super rich
    </div>
</template>

<script setup>
</script>